import * as React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Notice, Icon, Text } from '@siteground/styleguide';

import { ChatLayout } from '../../components/chat-layout';
import { ChatLogo } from '../../components/chat-logo';
import PresentationLayout from '../../components/presentation-layout/presentation-layout';
import { CHAT_STATE } from '../../constants';
import { getChatState } from '../../selectors/chat';
import { getLanguage, getUserData } from '../../selectors/chat-session';
import Translate from '../../components/translate/translate';

const NO_WELCOME_MESSAGE_STATES = [
  CHAT_STATE.NO_AVAILABLE_OPERATOR,
  CHAT_STATE.CURRENTLY_CHATTING,
  CHAT_STATE.FAILED_AUTHENTICATION_WITH_CLUSTER
];

const WaitingForOperator = () => {
  const intl = useIntl();
  const { firstName = '', lastName = '' } = useSelector(getUserData);
  const chatState = useSelector(getChatState);
  const name = lastName ? `${firstName} ${lastName}` : firstName; // NOTE: presale chat does not have lastName
  const language = useSelector(getLanguage);
  const showAiNotice = language !== 'en' && chatState === CHAT_STATE.REQUESTING_CHAT;

  const message = !NO_WELCOME_MESSAGE_STATES.includes(chatState)
    ? intl.formatMessage({ id: 'translate.welcome.message' })
    : undefined;

  return (
    <ChatLayout
      header={<ChatLogo />}
      content={
        <PresentationLayout
          title={intl.formatMessage({ id: 'translate.chat.welcome.time' }, { name })}
          message={message}
          icon={<Icon name="illustration-support-chat" width="152" height="116" multicolor />}
        >
          {chatState === CHAT_STATE.NO_AVAILABLE_OPERATOR && (
            <Notice type="warning">{intl.formatMessage({ id: 'translate.no.operator.available' })}</Notice>
          )}

          {chatState === CHAT_STATE.CURRENTLY_CHATTING && (
            <Notice type="warning">{intl.formatMessage({ id: 'translate.currently.chatting' })}</Notice>
          )}

          {chatState === CHAT_STATE.FAILED_AUTHENTICATION_WITH_CLUSTER && (
            <Notice type="warning">{intl.formatMessage({ id: 'translate.generic.notification.error' })}</Notice>
          )}
          {showAiNotice && (
            <Text size="large" align="center">
              <Translate id="translate.system.message.chat.ai.assistance.is.used" />
            </Text>
          )}
        </PresentationLayout>
      }
    />
  );
};

export default WaitingForOperator;
